const siteConfig = {
  phone: "0161 882 5050",
  email: "orders@louvolite.com",
  address: "Louvolite,\nAshton Road, Hyde,\nCheshire, SK14 4BG",
}

export default siteConfig
